import {ActionWithPayload} from '../../../helpers/reduxHelpers';
import {CompanyModel} from '../../../models/api/companyModel';
import {ApiCustomEmojis, CustomEmojisModel} from '../../../models/api/customEmojiModel';
import {fetchApiAsync} from '../../../services/http/http';
import {ThunkAction} from '../../appThunk';
import {getCompany} from '../company/companySelectors';

/*
 * Action types.
 */

export enum CustomEmojiActionsEnum {
  CUSTOM_EMOJIS_INITIALIZED = '@@data/custom_emojis/CUSTOM_EMOJI_INITIALIZED',
  CUSTOM_EMOJIS_CREATED = '@@data/custom_emojis/CUSTOM_EMOJI_CREATED',
  CUSTOM_EMOJIS_DELETED = '@@data/custom_emojis/CUSTOM_EMOJI_DELETED',
}

/*
 * Types.
 */

export interface CustomEmojiInitializedAction extends ActionWithPayload<CustomEmojisModel> {
  type: CustomEmojiActionsEnum.CUSTOM_EMOJIS_INITIALIZED;
}

export interface CustomEmojiCreatedAction {
  type: CustomEmojiActionsEnum.CUSTOM_EMOJIS_CREATED;
  payload: string;
}

export interface CustomEmojiDeletedAction {
  type: CustomEmojiActionsEnum.CUSTOM_EMOJIS_DELETED;
  payload: string;
}

function fetchInitialCustomEmojisAsync(company: CompanyModel) {
  const url = `${company.url}/custom_emojis`;
  return fetchApiAsync(ApiCustomEmojis, url);
}

/*
 * Action creators.
 */

export function initializeCustomEmojiAction(): ThunkAction {
  return async (dispatch, getState) => {
    try {
      const company = getCompany(getState());
      const emojis = await fetchInitialCustomEmojisAsync(company);

      const action: CustomEmojiInitializedAction = {
        type: CustomEmojiActionsEnum.CUSTOM_EMOJIS_INITIALIZED,
        payload: emojis,
      };

      dispatch(action);
    } catch (error) {
      // TODO: Error handling
    }
  };
}

export function createdCustomEmojiAction(shortcode: string): CustomEmojiCreatedAction {
  return {
    type: CustomEmojiActionsEnum.CUSTOM_EMOJIS_CREATED,
    payload: shortcode,
  };
}

export function deletedCustomEmojiAction(shortcode: string): CustomEmojiDeletedAction {
  return {
    type: CustomEmojiActionsEnum.CUSTOM_EMOJIS_DELETED,
    payload: shortcode,
  };
}

export type CustomEmojiAction =
  | CustomEmojiInitializedAction
  | CustomEmojiCreatedAction
  | CustomEmojiDeletedAction;
